import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Neighbours } from '../../sb-editor-tools/neighbours/models/neighbours.model';
import { NeighboursComponent } from '../../sb-editor-tools/neighbours/neighbours.component';
import { ToolsService } from '../../sb-editor-tools/services/tools.service';
import { Translation } from '../../sb-editor-tools/translation/models/translation.model';
import { TranslationComponent } from '../../sb-editor-tools/translation/translation.component';
import { SblibService } from '../../services/sblib.service';
import { ToastrService } from 'ngx-toastr';
import { Exceptions } from '@3ddv/ngx-sites-builder-lib';
import { ExceptionsComponent } from '../../sb-editor-tools/exceptions/exceptions.component';

@Component({
  selector: 'app-extern',
  templateUrl: './extern.component.html',
  styleUrls: ['./extern.component.scss'],
})
export class ExternComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  private toolgroup: {
    translation: Translation;
    neighbours: Neighbours;
    exceptions: Exceptions;
  };
  public tabs = {
    active: 'translation',
  };
  translationTool: boolean;
  neighboursTool: boolean;
  exceptionsTool: boolean;

  @ViewChild('translation', { static: false }) translationComponent: TranslationComponent;
  @ViewChild('neighbours', { static: false }) neighboursComponent: NeighboursComponent;
  @ViewChild('exceptions', { static: false }) exceptionsComponent: ExceptionsComponent;

  constructor(
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.subscriptions = [];
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.translation) {
        this.translationTool = true;
      } else {
        this.translationTool = false;
      }

      if (res.neighbours) {
        this.neighboursTool = true;
      } else {
        this.neighboursTool = false;
      }

      if (res.exceptions) {
        this.exceptionsTool = true;
      } else {
        this.exceptionsTool = false;
      }

      this.toolgroup = {
        translation: Object.assign({}, res.translation),
        neighbours: Object.assign({}, res.neighbours),
        exceptions: Object.assign({}, res.exceptions),
      };
      console.log(this.toolgroup);
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public save() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (this.tabs.active === 'translation') {
        res.translation = Object.assign({}, this.translationComponent.getTool());
      }
      if (this.tabs.active === 'neighbours') {
        res.neighbours = Object.assign({}, this.neighboursComponent.getTool());
      }
      if (this.tabs.active === 'exceptions') {
        res.exceptions = Object.assign({}, this.exceptionsComponent.getTool());
      }

      this.sblibService.apply(res);
      this.toastrService.success('', 'Changes applied');
    });
    this.subscriptions.push(tools$);
  }

  public getTool(tool: Translation | Neighbours | Exceptions, toolkey: string) {
    this.toolgroup[toolkey] = JSON.parse(JSON.stringify(tool));
  }
}
